class Tabs {
    constructor() {
        this.JUGAR_TAB = 1;
        this.RETOS_TAB = 2;
        this.RANKING_TAB = 3;
        this.AMIGOS_TAB = 4;
        this.QUIZFIT_TAB = 5;
        this.LINKS_TAB = 6;
        this.HELP_TAB = 9;
        this.CHAT_TAB = 19;
    }
}